import { useState } from "react";
import { faqs } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
          <SectionHeading
            eyebrow="常见问题"
            title="关于本站，你可能想问的"
            description="下面整理了关于片单、评分和观看方式的高频疑问。点击任意问题即可展开查看说明。"
          />

          <div className="space-y-3">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {item.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-100 text-foreground-700"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <div className="px-5 pb-5">
                      <p className="text-sm leading-relaxed text-foreground-600">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}